import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Flex, IconCheckmarkCircle, IconExclamationCircle } from '@zillow/constellation';
import { Button, Paragraph } from '@zillow/constellation-10';

import { StyledCard } from './StyledComponents';
import MESSAGE_MODULE_TYPES from '../../MESSAGE_MODULE_TYPES';

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaPrimaryButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  ctaSecondaryButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  closeMessageModule: PropTypes.func.isRequired,
  dismissibleActionId: PropTypes.string,
};

const defaultProps = {
  ctaPrimaryButton: null,
  ctaSecondaryButton: null,
  dismissibleActionId: null,
};

const PaymentsMessageModule = ({
  title,
  description,
  ctaPrimaryButton,
  ctaSecondaryButton,
  type,
  closeMessageModule,
  dismissibleActionId,
}) => {
  if (type === MESSAGE_MODULE_TYPES.CONFIRMATION) {
    return (
      <StyledCard isDisabled={true} data-test="confirmation-payments-message-card">
        <Flex display="flex" justifyContent="space-between">
          <Paragraph textStyle="body-bold">{title}</Paragraph>
          <IconCheckmarkCircle size="sm" fontColor="green400" />
        </Flex>
        <Paragraph textStyle="body-sm" css={{ paddingTop: '400', paddingBottom: '600' }}>
          {description}
        </Paragraph>
        {ctaPrimaryButton && ctaPrimaryButton.text && ctaPrimaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="filled"
            size="sm"
            fluid={true}
            data-test="confirmation-payments-card-primary-cta"
            textStyle="body-sm-bold"
            css={{ whiteSpace: 'nowrap' }}
          >
            <a href={ctaPrimaryButton.url}>{ctaPrimaryButton.text}</a>
          </Button>
        )}
        {ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="outlined"
            size="sm"
            fluid={true}
            data-test="confirmation-payments-card-secondary-cta"
            textStyle="body-sm-bold"
            css={{ marginTop: '200', whiteSpace: 'nowrap' }}
          >
            <a href={ctaSecondaryButton.url}>{ctaSecondaryButton.text}</a>
          </Button>
        )}
      </StyledCard>
    );
  }

  if (type === MESSAGE_MODULE_TYPES.DISMISSIBLE_CONFIRMATION) {
    return (
      <StyledCard isDisabled={true} data-test="dismissible-confirmation-payments-message-card">
        <Flex display="flex" justifyContent="space-between">
          <Paragraph textStyle="body-bold">{title}</Paragraph>
          <IconCheckmarkCircle size="sm" fontColor="green400" />
        </Flex>
        <Paragraph textStyle="body-sm" css={{ paddingTop: '400', paddingBottom: '600' }}>
          {description}
        </Paragraph>
        {ctaPrimaryButton && ctaPrimaryButton.text && (
          <Button
            tone="brand"
            emphasis="filled"
            size="sm"
            fluid={true}
            data-test="dismissible-confirmation-payments-card-primary-cta"
            onClick={() => closeMessageModule(dismissibleActionId)}
            textStyle="body-sm-bold"
            css={{ whiteSpace: 'nowrap' }}
          >
            {ctaPrimaryButton.text}
          </Button>
        )}
        {ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="outlined"
            size="sm"
            fluid={true}
            data-test="dismissible-confirmation-payments-card-secondary-cta"
            textStyle="body-sm-bold"
            css={{ marginTop: '200', whiteSpace: 'nowrap' }}
          >
            <a href={ctaSecondaryButton.url}>{ctaSecondaryButton.text}</a>
          </Button>
        )}
      </StyledCard>
    );
  }
  if (type === MESSAGE_MODULE_TYPES.WARNING) {
    return (
      <StyledCard isDisabled={true} data-test="warning-payments-message-card" type={type}>
        <Flex display="flex" justifyContent="space-between">
          <Paragraph textStyle="body-bold">{title}</Paragraph>
          <IconExclamationCircle size="sm" fontColor="caution" />
        </Flex>
        <Paragraph textStyle="body-sm" css={{ paddingTop: '400', paddingBottom: '600' }}>
          {description}
        </Paragraph>
        {ctaPrimaryButton && ctaPrimaryButton.text && ctaPrimaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="filled"
            size="sm"
            fluid={true}
            data-test="warning-payments-card-primary-cta"
            textStyle="body-sm-bold"
            css={{ whiteSpace: 'nowrap' }}
          >
            <a href={ctaPrimaryButton.url}>{ctaPrimaryButton.text}</a>
          </Button>
        )}
        {ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url && (
          <Button
            asChild
            tone="brand"
            emphasis="outlined"
            size="sm"
            fluid={true}
            data-test="warning-payments-card-secondary-cta"
            textStyle="body-sm-bold"
            css={{ marginTop: '200', whiteSpace: 'nowrap' }}
          >
            <a href={ctaSecondaryButton.url}>{ctaSecondaryButton.text}</a>
          </Button>
        )}
      </StyledCard>
    );
  }

  return null;
};

PaymentsMessageModule.propTypes = propTypes;
PaymentsMessageModule.defaultProps = defaultProps;

export default PaymentsMessageModule;
